import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.interfaceGray200};
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.interfaceText900};
  margin: 0;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.interfaceGray100};
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InstructionText = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.interfaceText600};
  margin: 0;
  line-height: 1.5;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label<{ required?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.interfaceText900};
  
  ${(props) => props.required && `
    &::after {
      content: '*';
      color: ${props.theme.colors.primaryRed400};
      margin-left: 4px;
    }
  `}
`;

export const DateTimeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DatePickerContainer = styled.div`
  flex: 1;
`;

export const TimezoneReadonly = styled.div`
  padding: 8px 12px;
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.interfaceText700};
  min-width: 60px;
  text-align: center;
  font-weight: 500;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.primaryRed400};
  margin-top: 4px;
`;

export const ModalFooter = styled.div`
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${(props: any) => props.theme.colors.interfaceGray200};
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

